import React from 'react';
import ReportsTab from '../components/ReportsTab';
import '../styles-super-admin-dashboard.css';

const SuperAdminReports = () => {
  return (
    <div className="super-admin-page reports-page">
      <ReportsTab />
    </div>
  );
};

export default SuperAdminReports;

